<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/project/details/', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">Zum Projekt </a>
    </li>
  </ul>
</nav>

<main *ngIf="job">
  <h2>Job {{ projectId }}.0006.{{ jobId }}</h2>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Job vom: {{ job.job_date | date: 'dd.MM.yyyy'  }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}
      <clr-dropdown [clrCloseMenuOnItemClick]="true">
        <button clrDropdownTrigger aria-label="Dropdown job status button">
            <cds-icon shape="angle" direction="down"></cds-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen>
          <label class="dropdown-header" aria-hidden="true">Status ändern</label>
            <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
            <div clrDropdownItem *ngFor="let item of statusButtons let i = index" (click)="changeJobStatus(projectId, jobId, i)">{{ item.display }}</div>
        </clr-dropdown-menu>
      </clr-dropdown>
    </span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          <div>{{ job.name_project }} (EK: {{  purchasingSum | currency: 'EUR':'code':'1.2-2':'de' }} / VK: {{ sellingSum | currency: 'EUR':'code':'1.2-2':'de' }})</div>
          <hr *ngIf="job.name_project">
          <cds-icon shape="upload" size="l" (click)="showFileUploader()"></cds-icon> <small class="ml1"> Kundenbestellung archivieren </small>
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-5">
                      <div class="clr-row">
                        <div class="clr-col-6">
                          <span>Kunde</span>
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/contact/details', companyId ]"></cds-icon>
                        </div>
                        <div class="clr-col-5">
                          {{ job.company_name }}<br /><span *ngIf="job.department">{{ job.department }} <br /></span> {{ job.street }}<br />{{ job.postcode }} {{ job.city }}
                          <span *ngIf="job.country !== 'Deutschland'">{{ job.country }}</span>
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          <span>Bestellnummer des Kunden:</span>
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          {{ job.order_id }}
                          <table class="table table-compact" *ngIf="orderFiles.length > 0">
                            <tbody>
                            <tr *ngFor="let orderFile of orderFiles">
                              <td><cds-icon shape="file" size="l" *ngIf="orderFile.fileType === 'application/pdf'" (click)="showModal(orderFile.id)"></cds-icon></td>
                              <td class="left">{{ orderFile.description }}</td>
                              <td class="left">{{ orderFile.fileName }}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="clr-col-5"></div>
                      </div>
                      <div *ngIf="(!!person)" class="clr-row">
                        <div class="clr-col-6">
                          <span>Ansprechpartner beim Kunden:</span>
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/person/details', person.pid ]"></cds-icon>
                        </div>
                        <div class="clr-col-5">
                          {{ person.salutation }} {{ person.firstname }} {{ person.lastname }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Angebotsbedingungen:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          {{ offerCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Zahlungsbedingungen:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          {{ paymentCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Lieferung:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          {{ deliveryCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Bemerkungen zur Lieferzeit:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          {{ job.delivery_remarks }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Lieferdatum:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          <span *ngIf="job.delivery_date !== '0000-00-00'">{{ job.delivery_date | date: "dd.MM.yyyy" }}</span>
                          <span *ngIf="job.delivery_date === '0000-00-00'">---</span>
                        </div>
                      </div>
                      <div class="clr-row" *ngIf="((job.company_name !== job.delivery_company) || (job.street !== job.delivery_street) || (job.city !== job.delivery_city) || (job.postcode !== job.delivery_postcode) || (job.country !== job.delivery_country))">
                        <div class="clr-col-6">
                          <br />Abweichende Lieferanschrift:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          <br />{{ job.delivery_company }}<br /><span *ngIf="job.delivery_department">{{ job.delivery_department }} <br /></span> {{ job.delivery_street }}<br />{{ job.delivery_postcode }} {{ job.delivery_city }}
                          <span *ngIf="job.delivery_country !== 'Deutschland'">{{ job.delivery_country }}</span>
                        </div>
                      </div>
                      <div class="clr-row" *ngIf="((job.company_name !== job.invoice_company) || (job.street !== job.invoice_street) || (job.city !== job.invoice_city) || (job.postcode !== job.invoice_postcode) || (job.country !== job.invoice_country))">
                        <div class="clr-col-6">
                          <br />Abweichende Rechnungsanschrift:
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          <br />{{ job.invoice_company }}<br /><span *ngIf="job.invoice_department">{{ job.invoice_department }} <br /></span> {{ job.invoice_street }}<br />{{ job.invoice_postcode }} {{ job.invoice_city }}
                          <span *ngIf="job.invoice_country !== 'Deutschland'">{{ job.invoice_country }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="clr-col-7">
                      <div class="clr-row">
                        <div class="clr-col-2">
                          Kommentare
                        </div>
                        <div class="clr-col-10">
                          <app-comment-feature-card [projectId]=projectId [companyId]=companyId [staffId]=job.employee_phm [subId]=jobId [commentType]=6></app-comment-feature-card>
                        </div>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/job/update', projectId, jobId]"> Job bearbeiten</button>
                    <button *ngIf="!!job" class="btn" (click)="basic = true; createMemo(projectId, jobId)">Memo</button>
                    <button class="btn" (click)="exportToExcel(positions)">Werkstattliste erstellen</button>
                    <button *ngIf="editPos === 0" class="btn btn-primary btn-sm" (click)="createNotification(projectId, jobId)">Mitteilung</button>
                    <button class="btn btn-danger" (click)="deleteJob(projectId, jobId)">Job löschen</button>
                    <button class="btn btn-warning" (click)="calculateEkVk(projectId, jobId)">Test EK/VK Berechnung</button>
                  </div>

                  <clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
                    <h3 class="modal-title">MEMO {{ projectId }}.0006.{{ jobId }}</h3>
                    <div id="documentContainer" class="modal-body"></div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
                      <button type="button" class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
                      <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
                      <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
                    </div>
                  </clr-modal>

                  <clr-datagrid *ngIf="editPos === 0" [clrDgLoading]="loading2">
                    <clr-dg-column>Position</clr-dg-column>
                    <clr-dg-column>Anzahl</clr-dg-column>
                    <clr-dg-column>Geliefert</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column [clrDgField]="'serial_nr'">Kennzeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
                    <clr-dg-column>Bemerkungen</clr-dg-column>
                    <clr-dg-column>Label</clr-dg-column>
                    <clr-dg-column>Angebot (in EUR)</clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Job {{ projectId }}.0004.{{ jobId }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i;">
                      <clr-dg-cell><span *ngIf="(position?.part ?? 0) > 0"><cds-icon shape="child-arrow"></cds-icon></span>{{ position.position }}<span *ngIf="(position?.part ?? 0) > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="((!position.technology) || (position.number_of_pieces > 0))">{{ position.number_of_pieces }}</span> </clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="!position.technology">{{ position.pieces_delivered }}</span> </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />TARIC: {{ position.taric }}</span>
                        <span *ngIf="!position.active"><br /><br /><button *ngIf="!position.active" class="btn btn-warning btn-sm">PASSIV! {{ warnPassiv() }}</button></span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <span *ngIf="position.technology"><cds-icon shape="cog" solid="true"></cds-icon></span>
                        {{ position.technical_drawing }}
                      </clr-dg-cell>
                      <clr-dg-cell>
                        {{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification">{{ position.specification }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell><cds-icon shape="printer" solid="true" (click)="printLabel(position)"></cds-icon></clr-dg-cell>
                      <clr-dg-cell class="right currency"><b>{{ position.selling_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                      <clr-dg-row-detail *clrIfExpanded clrLoading>
                        <table class="table">
                          <tbody>
                          <tr>
                            <td class="currency">Bestellungen bei Lieferanten:</td>
                            <td>
                              <app-job-details-orders [jobid]="jobId" [ordprid]="projectId" [ordposid]="position.position.toString()" [ordpartid]="position.part ?? 0"></app-job-details-orders>
                            </td>
                          </tr>
                          <tr>
                            <td class="currency">Lieferungen an den Kunden:</td>
                            <td>
                              <app-job-details-deliveries [jobid]="jobId" [delprid]="projectId" [delposid]="position.position.toString()" [delpartid]="position.part ?? 0" [deliveryID]="0" [posList]="false"></app-job-details-deliveries>
                            </td>
                          </tr>
                          <tr>
                            <td class="currency">Anfragen bei Lieferanten:</td>
                            <td>
                              <app-job-details-requests [jobid]="jobId" [reqprid]="projectId" [reqposid]="position.position.toString()" [reqpartid]="position.part ?? 0"></app-job-details-requests>
                            </td>
                          </tr>
                          <tr>
                            <td class="currency">Beistellungen:</td>
                            <td>
                              <app-job-details-warehouse-position [projectId]="projectId" [jobId]="jobId" [positionId]="position.position" [partId]="position.part ?? 0" [technicalDrawing]="position.technical_drawing ?? ''"></app-job-details-warehouse-position>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </clr-dg-row-detail>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <clr-datagrid *ngIf="editPos === 1" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-dg-action-bar>
                      <div class="btn-group" *ngIf="(statusText === 'Entwurf')">
                        <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Postionen löschen</button>
                      </div>
                    </clr-dg-action-bar>
                    <clr-dg-column [clrDgField]="'position'">Position</clr-dg-column>
                    <clr-dg-column [clrDgField]="'number_of_pieces'">Anzahl</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column [clrDgField]="'serial_nr'">Kennzeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
                    <clr-dg-column>Bemerkungen</clr-dg-column>
                    <clr-dg-column>Angebot</clr-dg-column>
                    <clr-dg-column></clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Job {{ projectId }}.0004.{{ jobId }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i;" [clrDgItem]="position">
                      <clr-dg-cell><span *ngIf="(position?.part ?? 0) > 0"><cds-icon shape="child-arrow"></cds-icon></span>{{ position.position }}<span *ngIf="(position?.part ?? 0) > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="!position.technology">{{ position.number_of_pieces }}</span> </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />TARIC: {{ position.taric }}</span>
                        <span *ngIf="!position.active"><br /><br /><button *ngIf="!position.active" class="btn btn-warning btn-sm">PASSIV! {{ warnPassiv() }}</button></span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <span *ngIf="position.technology"><cds-icon shape="cog" class="is-solid"></cds-icon></span>
                        {{ position.technical_drawing }}
                      </clr-dg-cell>
                      <clr-dg-cell>
                        {{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification">{{ position.specification }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell class="right currency"><b>{{ position.selling_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                      <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                        <button class="btn btn-sm" (click)="updatePositionMode(i, position.position, position.part ?? 0)">
                          <cds-icon shape="pencil"></cds-icon>
                          <span class="clr-icon-title">Ändern</span>
                        </button>
                      </clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-job-edit-position [projectNumber]="projectId" [jobNumber]="jobId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2"  (updatedPosition)="updateJob($event)"></app-job-edit-position>
                  <br *ngIf="(editPos === 1)"  />

                  <clr-dropdown *ngIf="(editPos === 1)" [clrCloseMenuOnItemClick]="false">
                    <button clrDropdownTrigger class="dropdown-toggle btn btn-link" aria-label="Dropdown positions button">
                      Projektposition hinzufügen
                      <cds-icon shape="angle" direction="down"></cds-icon>
                    </button>
                    <clr-dropdown-menu *clrIfOpen>
                      <div clrDropdownItem *ngFor="let components of foundPositions" (click)="addRow(components.position, components.positions_part ?? 0, components.technical_drawing, components.name)">{{ components.position }}.{{ components.positions_part }}  {{ components.name }} ({{ components.technical_drawing }})</div>
                    </clr-dropdown-menu>
                  </clr-dropdown>

                  <br *ngIf="(editPos === 1)"  /><br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="editPos = 1;">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                    <button *ngIf="(job.delivery_date !== '0000-00-00') && (editPos === 0)" class="btn" (click)="createConfirmation(projectId, jobId)">Auftrag bestätigen</button>
                    <button *ngIf="(job.delivery_date === '0000-00-00') && (editPos === 0)" class="btn" disabled>Auftrag bestätigen</button>
                    <button *ngIf="(job.status !== 'open') && (editPos === 0)" class="btn" (click)="createDeliveryNote(projectId, jobId)" [disabled]="allDelivered">Lieferschein erstellen</button>
                    <clr-tooltip *ngIf="allDelivered && (job.status !== 'open') && (editPos === 0)">
                      <cds-icon clrTooltipTrigger shape="info-circle" size="16"></cds-icon>
                      <clr-tooltip-content clrPosition="top-right" clrSize="md">Alle Positionen sind bereits vollständig geliefert.</clr-tooltip-content>
                    </clr-tooltip>
                  </div>

                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Orders</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-job-details-orderlist [projectID]="projectId" [jobID]="jobId"></app-job-details-orderlist>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Auftragsbestätigung</button>
                <clr-tab-content clrTabContentId="content3" *clrIfActive>
                  <app-job-details-confirmation [projectID]="projectId" [jobID]="jobId"></app-job-details-confirmation>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Mitteilungen</button>
                <clr-tab-content clrTabContentId="content4" *clrIfActive>
                  <app-job-details-notification [projectID]="projectId" [jobID]="jobId"></app-job-details-notification>
                </clr-tab-content>
              </clr-tab>

              <clr-tab *ngIf="job.status !== 'open'">
                <button clrTabLink>Lieferscheine</button>
                <clr-tab-content clrTabContentId="content5" *clrIfActive>
                  <app-job-details-delivery [projectId]="projectId" [jobId]="jobId"></app-job-details-delivery>
                </clr-tab-content>
              </clr-tab>

              <clr-tab *ngIf="job.status !== 'open'">
                <button clrTabLink>Rechnungen</button>
                <clr-tab-content clrTabContentId="content6" *clrIfActive>
                  <app-job-details-invoices [projectID]="projectId" [jobID]="jobId"></app-job-details-invoices>
                </clr-tab-content>
              </clr-tab>

              <clr-tab *ngIf="job.status !== 'open'">
                <button clrTabLink>Warenbewegungen</button>
                <clr-tab-content clrTabContentId="content6" *clrIfActive>
                  <app-job-details-warehouse [projectId]="projectId" [jobId]="jobId"></app-job-details-warehouse>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Controlling</button>
                <clr-tab-content clrTabContentId="content7" *clrIfActive>
                  <app-job-details-controlling [projectId]="projectId" [jobId]="jobId"></app-job-details-controlling>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content8" *clrIfActive>
                  <app-job-details-documents [projectId]="projectId" [jobId]="jobId"></app-job-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small *ngIf="!!job">Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ job.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-container *ngIf="showPdf">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>

<ng-container *ngIf="showFileUpload">
  <clr-modal id="fileUploader" [(clrModalOpen)]="showFileUpload" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">Kundenbestellung archivieren</h3>
    <div class="modal-body">
      <app-upload [componentId]="'0'" [projectId]="projectId" [companyId]=0  [jobId]="jobId" [subId]=0 [docType]=98 (closeModalEvent)="closeModal($event)"></app-upload>
    </div>
  </clr-modal>
</ng-container>

<clr-modal [(clrModalOpen)]="showDeliveryModal" [clrModalSize]="'lg'">
  <h3 class="modal-title">Lieferschein erstellen – Positionen auswählen</h3>
  <div class="modal-body">
    <p class="p6">Bitte wählen Sie die Lagerpositionen aus, die in den Lieferschein übernommen werden sollen.</p>
    <clr-datagrid>
      <clr-dg-column style="width:60px">Pos.</clr-dg-column>
      <clr-dg-column style="width:50px">Teil</clr-dg-column>
      <clr-dg-column>Zeichnung / Bezeichnung</clr-dg-column>
      <clr-dg-column>Seriennummer</clr-dg-column>
      <clr-dg-column>Chargennummer</clr-dg-column>
      <clr-dg-column style="width:60px">Menge</clr-dg-column>
      <clr-dg-column style="width:100px">Auswahl</clr-dg-column>
      <clr-dg-row *ngFor="let item of deliverySelectables">
        <clr-dg-cell>{{ item.position_no }}</clr-dg-cell>
        <clr-dg-cell>{{ item.part }}</clr-dg-cell>
        <clr-dg-cell>{{ item.technical_drawing || item.name || '—' }}</clr-dg-cell>
        <clr-dg-cell>{{ item.serial_nr || '—' }}</clr-dg-cell>
        <clr-dg-cell>{{ item.heat_nr || '—' }}</clr-dg-cell>
        <clr-dg-cell>{{ item.number_of_pieces }}</clr-dg-cell>
        <clr-dg-cell><input type="checkbox" clrCheckbox [checked]="selectedDeliveryWarehouseIds.has(item.warehouse_id)" (change)="toggleDeliveryWarehouseSelection(item.warehouse_id)" /></clr-dg-cell>
      </clr-dg-row>
    </clr-datagrid>
    <button class="btn btn-sm btn-link" (click)="selectAllDeliveryWarehouses()">Alle auswählen</button>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline" (click)="showDeliveryModal = false">Abbrechen</button>
    <button class="btn btn-primary" [disabled]="selectedDeliveryWarehouseIds.size === 0" (click)="confirmDeliveryModal()">Lieferschein erstellen</button>
  </div>
</clr-modal>
